import * as React from 'react';
import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import NetworkService from './networkService';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import { QRCode } from 'react-qrcode-logo';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { LinearProgress, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, CircularProgress, Divider } from '@mui/material';

const networkService = new NetworkService();

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function Network() {
    const [loading, setLoading] = React.useState(false);
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const [currConfig, setCurrConfig] = useState({});

    const [status, setStatus] = useState(
        {
            "wifi": {
                "enabled": "true",
                "ssid": "FastRTK",
                "passphrase": "fastrtk!",
                "country": "us"
            },
            "lan": {
                "ip": "0.0.0.0",
                "gateway": "0.0.0.0",
                "subnet": "255.255.255.0",
                "dns": "0.0.0.0",
                "externalIP": "0.0.0.0"
            }
        }
    );

    const [wifiEnabled, setWifiEnabled] = useState(true);
    const [wifiLoading, setWifiLoading] = useState(false);
    const [wifiSSID, setWifiSSID] = useState("");
    const [wifiPassphrase, setWifiPassphrase] = useState("");
    const [wifiCountry, setWifiCountry] = useState("");

    const [networktype, setNetworktype] = useState("dhcp");

    const [staticIP, setStaticIP] = useState("");
    const [staticIPvalid, setStaticIPvalid] = useState(true);

    const [staticRouter, setStaticRouter] = useState("");
    const [staticRoutervalid, setStaticRoutervalid] = useState(true);

    const [staticNetMask, setStaticNetMask] = React.useState("");

    const [staticDNS1, setStaticDNS1] = useState("");
    const [staticDNS1valid, setStaticDNS1valid] = useState(true);

    const [staticDNS2, setStaticDNS2] = useState("");
    const [staticDNS2valid, setStaticDNS2valid] = useState(true);

    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [applyingChanges, setApplyingChanges] = useState(false);
    const [pendingNetworkChange, setPendingNetworkChange] = useState(null);



    useEffect(() => {
        setLoading(true);
        Promise.all([
            networkService.getNetwork(),
            networkService.getWifiStatus()
        ]).then(([networkResponse, wifiResponse]) => {
            setCurrConfig({
                "type": networkResponse.type,
                "ip": networkResponse.ip,
                "mask": networkResponse.mask,
                "gateway": networkResponse.gateway,
                "dns": networkResponse.dns,
                "port": networkResponse.gateway,
                "wifi": networkResponse.wifi,
                "pswd": networkResponse.pswd,
                "internalIP": networkResponse.internalIP ? networkResponse.internalIP.trim() : '',
                "externalIP": networkResponse.externalIP ? networkResponse.externalIP.trim() : '',
                "macAddress": networkResponse.mac_address,
                "hostname": networkResponse.hostname
            })
            setWifiSSID(wifiResponse.ssid || generateSSID(networkResponse.mac_address));
            setWifiEnabled(wifiResponse.enabled || false);
            setWifiPassphrase(wifiResponse.passphrase || 'fastrtk!');

            // Populate static IP form fields if network type is static
            if (networkResponse.type === 'static') {
                setNetworktype('static');
                setStaticIP(networkResponse.ip || '');
                setStaticRouter(networkResponse.gateway || '');
                setStaticNetMask(networkResponse.mask || '');
                if (networkResponse.dns && networkResponse.dns.length > 0) {
                    setStaticDNS1(networkResponse.dns[0] || '');
                    if (networkResponse.dns.length > 1) {
                        setStaticDNS2(networkResponse.dns[1] || '');
                    }
                }
            } else {
                setNetworktype(networkResponse.type || 'dhcp');
            }

            setLoading(false);
        }).catch(error => {
            console.error('Failed to load network settings:', error);
            setLoading(false);
        });
    }, []);

    const handleChangeNetmask = (event) => {
        setStaticNetMask(event.target.value);
    };

    const onIPChange = (event) => {
        let ip = cleanIP(event.target.value);
        setStaticIP(ip);
        setStaticIPvalid(validateIP(ip));
    };

    const onRouterChange = (event) => {
        let ip = cleanIP(event.target.value);
        setStaticRouter(ip);
        setStaticRoutervalid(validateIP(ip));
    };

    const onDNS1Change = (event) => {
        let ip = cleanIP(event.target.value);
        setStaticDNS1(ip);
        setStaticDNS1valid(validateIP(ip));
    };

    const onDNS2Change = (event) => {
        let ip = cleanIP(event.target.value);
        setStaticDNS2(ip);
        setStaticDNS2valid(validateIP(ip));
    };

    const setDefaultRouter = () => {
        if (staticRouter === "") {
            let router = staticIP.substr(0, staticIP.lastIndexOf(".") + 1);
            router = router + "1";
            setStaticRouter(router);
        }
    }

    const setDefaultDNS1 = () => {
        if (staticDNS1 === "") {
            let ip = staticIP.substr(0, staticIP.lastIndexOf(".") + 1);
            ip = ip + "1";
            setStaticDNS1(ip);
        }
    }

    const setDefaultDNS2 = () => {
        if (staticDNS1 === "") {
            setStaticDNS2("8.8.8.8");
        }
    }

    const validateIP = (ip) => {
        if (/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(ip)) {
            return true;
        }
        else {
            return false;
        }
    }

    const cleanIP = (ip) => {
        return ip.replace(/[^0-9.]/g, '');
    }

    function setDHCP() {
        setPendingNetworkChange({ type: "dhcp" });
        setConfirmDialogOpen(true);
    }

    function setStatic() {
        var params = {
            type: "static",
            ip: staticIP,
            netmask: staticNetMask,
            router: staticRouter,
            dns1: staticDNS1,
            dns2: staticDNS2
        };
        setPendingNetworkChange(params);
        setConfirmDialogOpen(true);
    }

    function handleConfirmNetworkChange() {
        setConfirmDialogOpen(false);
        setApplyingChanges(true);

        networkService.setNetwork(pendingNetworkChange).then(async () => {
            // Wait 30 seconds for device to reboot and apply changes
            await new Promise(r => setTimeout(r, 30000));

            // Redirect to new IP or refresh page
            if (pendingNetworkChange.type === "static") {
                window.location.href = 'http://' + pendingNetworkChange.ip;
            } else {
                alert("Network changed to DHCP. Please find the new IP address from your router and navigate to it.");
                setApplyingChanges(false);
            }
        })
        .catch(function (error) {
            setApplyingChanges(false);
            alert("Failed to set network configuration.");
        });
    }

    function handleCancelNetworkChange() {
        setConfirmDialogOpen(false);
        setPendingNetworkChange(null);
    }

    const handleNetworkType = (event, newNetworkType) => {
        setNetworktype(newNetworkType);
    };

    const handleWifiToggle = (event) => {
        const newState = event.target.checked;
        setWifiLoading(true);

        networkService.toggleWifi(newState).then(() => {
            setWifiEnabled(newState);
            setWifiLoading(false);
        }).catch(error => {
            console.error('Failed to toggle WiFi:', error);
            alert('Failed to toggle WiFi hotspot. Please check the console for details.');
            setWifiLoading(false);
        });
    };

    function generateSSID(value) {
        let mac = value;
        console.log("cleaned up: ", mac);
        let cleanedMac = mac.replace(/:/g, "");
        console.log("cleaned up: ", cleanedMac);
        let shortMac = cleanedMac.slice(-7);
        let ssid = shortMac.replace(/(\r\n|\n|\r)/gm, "");
        return "FastRTK-" + ssid;
    }

    return (
        <React.Fragment>
            <h1 className="page-title"><span className="fw-semi-bold">Network Settings</span></h1>
            <Box sx={{ width: '100%' }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                        <Tab label={<h5>LAN</h5>} {...a11yProps(0)} />
                        <Tab label={<h5>WiFI</h5>} {...a11yProps(1)} />
                        <Tab label={<h5>VPN</h5>} {...a11yProps(2)} />
                    </Tabs>
                </Box>
                {loading ? <LinearProgress /> : (
                    <React.Fragment>
                <TabPanel value={value} index={0}>
                    <h3>Status</h3>
                    <strong>Configuration Type:</strong> {currConfig.type === 'static' ? 'Static IP' : 'DHCP'}
                    <br />
                    <strong>Internal IP:</strong> {currConfig.ip || currConfig.internalIP || 'Not assigned'}
                    <br />
                    <strong>Netmask:</strong> {currConfig.mask ? `/${currConfig.mask}` : 'N/A'}
                    <br />
                    <strong>Gateway:</strong> {currConfig.gateway || 'N/A'}
                    <br />
                    <strong>DNS Servers:</strong> {currConfig.dns && currConfig.dns.length > 0 ? currConfig.dns.join(', ') : 'N/A'}
                    <br />
                    <strong>Public IP:</strong> {currConfig.externalIP || 'N/A'}
                    <br />
                    <strong>MAC Address:</strong> {currConfig.macAddress || 'N/A'}
                    <br /><br />
                    <h3>Configure</h3>
                    <Stack spacing={2} direction="column" alignItems="center" style={{ maxWidth: "20em" }}>
                        <ToggleButtonGroup
                            value={networktype}
                            exclusive
                            onChange={handleNetworkType}
                            aria-label="Network type"
                        >
                            <ToggleButton value="dhcp">DHCP</ToggleButton>
                            <ToggleButton value="static">Static</ToggleButton>
                        </ToggleButtonGroup>

                        {networktype === "static" ? (
                            <React.Fragment>
                                <TextField
                                    fullWidth
                                    id="static-ip"
                                    label="Static IP"
                                    onChange={onIPChange}
                                    value={staticIP}
                                    error={!staticIPvalid}
                                    helperText={!staticIPvalid ? "Invalid IP address" : "Enter a valid IP address."}
                                />
                                <FormControl fullWidth>
                                    <InputLabel id="static-netmask">Netmask</InputLabel>
                                    <Select
                                        labelId="static-netmask"
                                        id="static-netmask-select"
                                        value={staticNetMask}
                                        label="Netmask"
                                        onChange={handleChangeNetmask}
                                    >
                                        <MenuItem value={30}>255.255.255.252</MenuItem>
                                        <MenuItem value={29}>255.255.255.248</MenuItem>
                                        <MenuItem value={28}>255.255.255.240</MenuItem>
                                        <MenuItem value={27}>255.255.255.224</MenuItem>
                                        <MenuItem value={26}>255.255.255.192</MenuItem>
                                        <MenuItem value={25}>255.255.255.128</MenuItem>
                                        <MenuItem value={24}>255.255.255.0</MenuItem>
                                        <MenuItem value={23}>255.255.254.0</MenuItem>
                                        <MenuItem value={22}>255.255.252.0</MenuItem>
                                        <MenuItem value={21}>255.255.248.0</MenuItem>
                                        <MenuItem value={20}>255.255.240.0</MenuItem>
                                        <MenuItem value={19}>255.255.224.0</MenuItem>
                                        <MenuItem value={18}>255.255.192.0</MenuItem>
                                        <MenuItem value={17}>255.255.128.0</MenuItem>
                                        <MenuItem value={16}>255.255.0.0</MenuItem>
                                    </Select>
                                </FormControl>
                                <TextField
                                    fullWidth
                                    id="static-router"
                                    label="Router"
                                    onChange={onRouterChange}
                                    onFocus={setDefaultRouter}
                                    value={staticRouter}
                                    error={!staticRoutervalid}
                                    helperText={!staticRoutervalid ? "Invalid IP address" : "Enter a valid IP address."}
                                />
                                <TextField
                                    fullWidth
                                    id="static-dns1"
                                    label="DNS 1"
                                    onChange={onDNS1Change}
                                    onFocus={setDefaultDNS1}
                                    value={staticDNS1}
                                    error={!staticDNS1valid}
                                    helperText={!staticDNS1valid ? "Invalid IP address" : "Enter a valid IP address."}
                                />
                                <TextField
                                    fullWidth
                                    id="static-dns2"
                                    label="DNS 2"
                                    onChange={onDNS2Change}
                                    onFocus={setDefaultDNS2}
                                    value={staticDNS2}
                                    error={!staticDNS2valid}
                                    helperText={!staticDNS2valid ? "Invalid IP address" : "Enter a valid IP address."}
                                />
                                <Button
                                    variant="text"
                                    onClick={setStatic}
                                >Set Static IP Configuration</Button>
                            </React.Fragment>
                        ) : (
                            <Button
                                variant="text"
                                onClick={setDHCP}
                            >Set DHCP IP Configuration</Button>
                        )}
                    </Stack>

                </TabPanel>
                <TabPanel value={value} index={1}>
                    <Stack direction="row" spacing={2} alignItems="center">
                        <h2>Status</h2>
                        {wifiLoading ? (
                            <CircularProgress size={24} />
                        ) : (
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={wifiEnabled}
                                        onChange={handleWifiToggle}
                                        color="success"
                                    />
                                }
                                label="Enabled"
                            />
                        )}
                    </Stack>
                    <strong>SSID:</strong> {wifiSSID}
                    <br />
                    <strong>Passphrase:</strong> {wifiPassphrase}
                    <br /><br />
                    {wifiEnabled && (
                        <>
                            <QRCode
                                fgColor="#1a4b87"
                                bgColor="#ffffff"
                                value={`WIFI:S:${wifiSSID};T:WPA2;P:${wifiPassphrase};H:false;`}
                                logoOpacity={0.5}
                                removeQrCodeBehindLogo={false}
                                qrStyle="dots"
                                logoWidth="120"
                                quietZone={15}
                                eyeRadius={0.1}
                                eyeColor="#1a4b87"
                            />
                            <br />
                            Scan QR code to connect.
                        </>
                    )}
                    {!wifiEnabled && (
                        <Typography variant="body1" color="text.secondary">
                            WiFi hotspot is currently disabled. Enable it to see connection details.
                        </Typography>
                    )}
                    <br />
                    {/* <br />
                    <h2>Configure</h2>
                    <Stack spacing={2} direction="column" style={{ maxWidth: "20em" }}>
                        <TextField
                            helperText="Enter an SSID."
                            id="wifi-ssid"
                            label="SSID"
                        />
                        <TextField
                            helperText="Enter a password."
                            id="wifi-password"
                            label="Password"
                        />
                        <Button variant="text">Save</Button>
                    </Stack> */}
                </TabPanel>
                <TabPanel value={value} index={2}>
                    <VPN />
                </TabPanel>
                    </React.Fragment>
                )}
            </Box>

            {/* Confirmation Dialog */}
            <Dialog open={confirmDialogOpen} onClose={handleCancelNetworkChange}>
                <DialogTitle>Confirm Network Configuration Change</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {pendingNetworkChange?.type === 'static'
                            ? `Are you sure you want to change to a static IP (${pendingNetworkChange?.ip})? The device will reboot and you will need to reconnect to the new IP address.`
                            : 'Are you sure you want to change to DHCP? The device will reboot and obtain an IP address from your router.'
                        }
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCancelNetworkChange}>Cancel</Button>
                    <Button onClick={handleConfirmNetworkChange} variant="contained" color="primary">
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Applying Changes Dialog */}
            <Dialog open={applyingChanges} disableEscapeKeyDown>
                <DialogTitle>Applying Network Settings</DialogTitle>
                <DialogContent>
                    <Stack spacing={2} alignItems="center" sx={{ py: 3 }}>
                        <CircularProgress size={60} />
                        <DialogContentText align="center">
                            Waiting for the device to use the new network settings...<br/>
                            This will take approximately 30 seconds.
                            {pendingNetworkChange?.type === 'static' && (
                                <>
                                    <br/><br/>
                                    You will be redirected to: <strong>{pendingNetworkChange?.ip}</strong>
                                </>
                            )}
                        </DialogContentText>
                    </Stack>
                </DialogContent>
            </Dialog>
        </React.Fragment >
    );
}


function VPN() {
    const [loading, setLoading] = useState(true);
    const [vpnType, setVpnType] = useState('wireguard');
    const [vpnStatus, setVpnStatus] = useState(null);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    // WireGuard fields
    const [wgServerPublicKey, setWgServerPublicKey] = useState('');
    const [wgServerEndpoint, setWgServerEndpoint] = useState('');
    const [wgClientPrivateKey, setWgClientPrivateKey] = useState('');
    const [wgClientAddress, setWgClientAddress] = useState('');
    const [wgAllowedIPs, setWgAllowedIPs] = useState('0.0.0.0/0, ::/0');
    const [wgDNS, setWgDNS] = useState('');

    // OpenVPN fields
    const [ovpnFile, setOvpnFile] = useState(null);
    const [ovpnFileName, setOvpnFileName] = useState('');
    const [ovpnUsername, setOvpnUsername] = useState('');
    const [ovpnPassword, setOvpnPassword] = useState('');

    useEffect(() => {
        fetchVpnStatus();
    }, []);

    const fetchVpnStatus = () => {
        setLoading(true);
        networkService.getVpnStatus().then(response => {
            setVpnStatus(response);
            if (response.type) {
                setVpnType(response.type);
            }
            // Populate WireGuard fields if they exist
            if (response.type === 'wireguard' && response.config) {
                setWgServerPublicKey(response.config.server_public_key || '');
                setWgServerEndpoint(response.config.server_endpoint || '');
                setWgClientAddress(response.config.client_address || '');
                setWgAllowedIPs(response.config.allowed_ips || '0.0.0.0/0, ::/0');
                setWgDNS(response.config.dns || '');
            }
            setLoading(false);
        }).catch(err => {
            console.error('Failed to fetch VPN status:', err);
            setLoading(false);
        });
    };

    const handleVpnTypeChange = (event, newType) => {
        if (newType !== null) {
            setVpnType(newType);
            setError('');
            setSuccess('');
        }
    };

    const generateWireGuardKeys = () => {
        networkService.generateWireGuardKeys().then(response => {
            setWgClientPrivateKey(response.private_key);
            setSuccess('Keys generated! Public key: ' + response.public_key);
        }).catch(err => {
            setError('Failed to generate keys: ' + (err.response?.data?.error || err.message));
        });
    };

    const handleWireGuardSubmit = () => {
        setError('');
        setSuccess('');
        setLoading(true);

        const config = {
            type: 'wireguard',
            server_public_key: wgServerPublicKey,
            server_endpoint: wgServerEndpoint,
            client_private_key: wgClientPrivateKey,
            client_address: wgClientAddress,
            allowed_ips: wgAllowedIPs,
            dns: wgDNS
        };

        networkService.configureVpn(config).then(() => {
            setSuccess('WireGuard VPN configured successfully!');
            fetchVpnStatus();
        }).catch(err => {
            setError('Failed to configure WireGuard: ' + (err.response?.data?.error || err.message));
            setLoading(false);
        });
    };

    const handleOpenVPNFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setOvpnFile(file);
            setOvpnFileName(file.name);
        }
    };

    const handleOpenVPNSubmit = () => {
        if (!ovpnFile) {
            setError('Please select an OpenVPN configuration file');
            return;
        }

        setError('');
        setSuccess('');
        setLoading(true);

        const formData = new FormData();
        formData.append('file', ovpnFile);
        formData.append('type', 'openvpn');
        if (ovpnUsername) {
            formData.append('username', ovpnUsername);
        }
        if (ovpnPassword) {
            formData.append('password', ovpnPassword);
        }

        networkService.uploadVpnConfig(formData).then((response) => {
            if (response.credentials_required) {
                setSuccess('OpenVPN configuration uploaded! Note: This config requires credentials - please enter username/password and re-upload.');
            } else {
                setSuccess('OpenVPN configuration uploaded successfully!');
            }
            fetchVpnStatus();
        }).catch(err => {
            setError('Failed to upload OpenVPN config: ' + (err.response?.data?.error || err.message));
            setLoading(false);
        });
    };

    const handleToggleVpn = () => {
        const newState = !vpnStatus?.enabled;
        setLoading(true);

        networkService.toggleVpn(newState).then(() => {
            setSuccess(`VPN ${newState ? 'enabled' : 'disabled'} successfully!`);
            fetchVpnStatus();
        }).catch(err => {
            setError(`Failed to ${newState ? 'enable' : 'disable'} VPN: ` + (err.response?.data?.error || err.message));
            setLoading(false);
        });
    };

    const handleDisconnect = () => {
        setLoading(true);
        networkService.disconnectVpn().then(() => {
            setSuccess('VPN disconnected and removed successfully!');
            fetchVpnStatus();
        }).catch(err => {
            setError('Failed to disconnect VPN: ' + (err.response?.data?.error || err.message));
            setLoading(false);
        });
    };

    if (loading) {
        return <LinearProgress />;
    }

    return (
        <React.Fragment>
            <Stack spacing={3}>
                {/* Status Section */}
                <Box>
                    <Stack direction="row" spacing={2} alignItems="center">
                        <Typography variant="h6">VPN Status:</Typography>
                        {vpnStatus?.configured ? (
                            <>
                                <Typography color={vpnStatus.connected ? 'success.main' : 'warning.main'}>
                                    {vpnStatus.connected ? 'Connected' : 'Configured but not connected'}
                                </Typography>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={vpnStatus.enabled || false}
                                            onChange={handleToggleVpn}
                                            color="success"
                                        />
                                    }
                                    label="Enabled"
                                />
                            </>
                        ) : (
                            <Typography color="text.secondary">Not configured</Typography>
                        )}
                    </Stack>
                    {vpnStatus?.configured && (
                        <Stack direction="row" spacing={2} sx={{ mt: 1 }}>
                            <Typography variant="body2">Type: <strong>{vpnStatus.type?.toUpperCase()}</strong></Typography>
                            {vpnStatus.connection_name && (
                                <Typography variant="body2">Connection: {vpnStatus.connection_name}</Typography>
                            )}
                        </Stack>
                    )}
                </Box>

                {/* Error/Success Messages */}
                {error && <Typography color="error">{error}</Typography>}
                {success && <Typography color="success.main">{success}</Typography>}

                {/* VPN Type Selector */}
                <Box>
                    <Typography variant="h6" gutterBottom>VPN Type</Typography>
                    <ToggleButtonGroup
                        value={vpnType}
                        exclusive
                        onChange={handleVpnTypeChange}
                        aria-label="VPN type"
                    >
                        <ToggleButton value="wireguard">WireGuard</ToggleButton>
                        <ToggleButton value="openvpn">OpenVPN</ToggleButton>
                    </ToggleButtonGroup>
                </Box>

                {/* WireGuard Configuration */}
                {vpnType === 'wireguard' && (
                    <Box>
                        <Typography variant="h6" gutterBottom>WireGuard Configuration</Typography>
                        <Stack spacing={3} sx={{ maxWidth: '600px' }}>

                            {/* Option 1: Upload Config File */}
                            <Box>
                                <Typography variant="subtitle1" gutterBottom>Option 1: Upload Configuration File</Typography>
                                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                                    Upload a complete WireGuard configuration file (.conf) if you have one.
                                </Typography>

                                {ovpnFileName && vpnType === 'wireguard' ? (
                                    <Stack spacing={1}>
                                        <Typography>Selected file: <strong>{ovpnFileName}</strong></Typography>
                                        <Button variant="outlined" component="label">
                                            Choose Different File
                                            <input
                                                type="file"
                                                hidden
                                                accept=".conf"
                                                onChange={handleOpenVPNFileChange}
                                            />
                                        </Button>
                                    </Stack>
                                ) : (
                                    <Button variant="outlined" component="label">
                                        Choose WireGuard Config File
                                        <input
                                            type="file"
                                            hidden
                                            accept=".conf"
                                            onChange={handleOpenVPNFileChange}
                                        />
                                    </Button>
                                )}

                                {ovpnFile && vpnType === 'wireguard' && (
                                    <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
                                        <Button variant="contained" onClick={handleOpenVPNSubmit}>
                                            Upload WireGuard Config
                                        </Button>
                                        {vpnStatus?.configured && (
                                            <Button variant="outlined" color="error" onClick={handleDisconnect}>
                                                Remove VPN
                                            </Button>
                                        )}
                                    </Stack>
                                )}
                            </Box>

                            <Divider />

                            {/* Option 2: Manual Configuration */}
                            <Box>
                                <Typography variant="subtitle1" gutterBottom>Option 2: Manual Configuration</Typography>
                                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                                    Or configure WireGuard manually by entering the details below.
                                </Typography>

                                <Stack spacing={2}>
                                    <Stack direction="row" spacing={2}>
                                        <Button variant="outlined" onClick={generateWireGuardKeys}>
                                            Generate Client Keys
                                        </Button>
                                        <Typography variant="caption" sx={{ alignSelf: 'center' }}>
                                            Click to generate a new key pair
                                        </Typography>
                                    </Stack>

                                    <TextField
                                        label="Client Private Key"
                                        value={wgClientPrivateKey}
                                        onChange={(e) => setWgClientPrivateKey(e.target.value)}
                                        placeholder="Generated private key will appear here"
                                        helperText="Keep this secret! Share only the public key with your VPN server admin."
                                        fullWidth
                                    />

                                    <TextField
                                        label="Server Public Key"
                                        value={wgServerPublicKey}
                                        onChange={(e) => setWgServerPublicKey(e.target.value)}
                                        placeholder="Server's public key"
                                        helperText="Get this from your VPN server administrator"
                                        required
                                        fullWidth
                                    />

                                    <TextField
                                        label="Server Endpoint"
                                        value={wgServerEndpoint}
                                        onChange={(e) => setWgServerEndpoint(e.target.value)}
                                        placeholder="vpn.example.com:51820"
                                        helperText="Server hostname/IP and port (e.g., vpn.example.com:51820)"
                                        required
                                        fullWidth
                                    />

                                    <TextField
                                        label="Client IP Address"
                                        value={wgClientAddress}
                                        onChange={(e) => setWgClientAddress(e.target.value)}
                                        placeholder="10.0.0.2/24"
                                        helperText="Your VPN IP address (assigned by server admin)"
                                        required
                                        fullWidth
                                    />

                                    <TextField
                                        label="Allowed IPs"
                                        value={wgAllowedIPs}
                                        onChange={(e) => setWgAllowedIPs(e.target.value)}
                                        placeholder="0.0.0.0/0, ::/0"
                                        helperText="Routes to push through VPN (default: all traffic)"
                                        fullWidth
                                    />

                                    <TextField
                                        label="DNS Servers (optional)"
                                        value={wgDNS}
                                        onChange={(e) => setWgDNS(e.target.value)}
                                        placeholder="1.1.1.1, 8.8.8.8"
                                        helperText="Comma-separated DNS servers"
                                        fullWidth
                                    />

                                    <Stack direction="row" spacing={2}>
                                        <Button
                                            variant="contained"
                                            onClick={handleWireGuardSubmit}
                                            disabled={!wgServerPublicKey || !wgServerEndpoint || !wgClientPrivateKey || !wgClientAddress}
                                        >
                                            Configure WireGuard
                                        </Button>
                                        {vpnStatus?.configured && (
                                            <Button variant="outlined" color="error" onClick={handleDisconnect}>
                                                Remove VPN
                                            </Button>
                                        )}
                                    </Stack>
                                </Stack>
                            </Box>
                        </Stack>
                    </Box>
                )}

                {/* OpenVPN Configuration */}
                {vpnType === 'openvpn' && (
                    <Box>
                        <Typography variant="h6" gutterBottom>OpenVPN Configuration</Typography>
                        <Stack spacing={2} sx={{ maxWidth: '600px' }}>
                            <Typography variant="body2">
                                Upload your OpenVPN configuration file (.ovpn). The file should contain all necessary
                                certificates and keys, or reference them if they're separate files.
                            </Typography>

                            {ovpnFileName ? (
                                <Stack spacing={1}>
                                    <Typography>Selected file: <strong>{ovpnFileName}</strong></Typography>
                                    <Button variant="outlined" component="label">
                                        Choose Different File
                                        <input
                                            type="file"
                                            hidden
                                            accept=".ovpn,.conf"
                                            onChange={handleOpenVPNFileChange}
                                        />
                                    </Button>
                                </Stack>
                            ) : (
                                <Button variant="contained" component="label">
                                    Select OpenVPN Config File
                                    <input
                                        type="file"
                                        hidden
                                        accept=".ovpn,.conf"
                                        onChange={handleOpenVPNFileChange}
                                    />
                                </Button>
                            )}

                            <Divider />

                            <Typography variant="subtitle2" color="text.secondary">
                                Authentication (if required by your VPN server)
                            </Typography>

                            <TextField
                                label="Username"
                                value={ovpnUsername}
                                onChange={(e) => setOvpnUsername(e.target.value)}
                                placeholder="VPN username"
                                helperText="Leave blank if your config doesn't require username/password"
                                fullWidth
                            />

                            <TextField
                                label="Password"
                                type="password"
                                value={ovpnPassword}
                                onChange={(e) => setOvpnPassword(e.target.value)}
                                placeholder="VPN password"
                                helperText="Leave blank if your config doesn't require username/password"
                                fullWidth
                            />

                            <Stack direction="row" spacing={2}>
                                <Button
                                    variant="contained"
                                    onClick={handleOpenVPNSubmit}
                                    disabled={!ovpnFile}
                                >
                                    Upload & Configure
                                </Button>
                                {vpnStatus?.configured && (
                                    <Button variant="outlined" color="error" onClick={handleDisconnect}>
                                        Remove VPN
                                    </Button>
                                )}
                            </Stack>
                        </Stack>
                    </Box>
                )}
            </Stack>
        </React.Fragment>
    );
}